




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { formatVentUnits } from "@/filters/ventFields";
import { VentMonitorModel, VentSettingModel } from "@/models";

@Component
export default class VentLabel extends Vue {
  @Prop() readonly monitor?: { [field in keyof VentMonitorModel]: string };
  @Prop() readonly settings?: { [field in keyof VentSettingModel]: string };
  @Prop() readonly field!: keyof VentMonitorModel | keyof VentSettingModel;
  @Prop() readonly label!: string;

  get isMonitor(): boolean {
    return !!this.monitor && Object.keys(this.monitor).indexOf(this.field) >= 0;
  }

  get isSetting(): boolean {
    return !!this.settings && Object.keys(this.settings).indexOf(this.field) >= 0;
  }

  get units() {
    if (this.isMonitor) return this.monitor![this.field as keyof VentMonitorModel];
    else if (this.isSetting) return this.settings![this.field as keyof VentSettingModel];
    else return undefined;
  }

  get labelWithUnits() {
    const units = formatVentUnits(this.units);
    if (units) return `${this.label} (${units})`;
    else return this.label;
  }
}
